import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

Vue.use(Router)

const stallRoutes = [
  {
    path: '/stall/stall',
    name: 'stallList',
    component: resolve => require(['../page/stall/stall'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete',
        stallTag: 'stallTag',
        stallClass: 'stallClass'
      }
    }
  },
  {
    path: '/stall/stall/tag',
    name: 'tagList',
    component: resolve => require(['../page/stall/tag'], resolve),
    meta: {
      framePage: true,
      permissions: {
        createStallTag: 'createStallTag',
        updateStallTag: 'updateStallTag',
        deleteStallTag: 'deleteStallTag'
      }
    }
  },
  {
    path: '/stall/stall/class',
    name: 'classList',
    component: resolve => require(['../page/stall/class'], resolve),
    meta: {
      framePage: true,
      permissions: {
        createStallClass: 'createStallClass',
        updateStallClass: 'updateStallClass',
        deleteStallClass: 'deleteStallClass'
      }
    }
  },
  {
    path: '/stall/device',
    name: 'deviceList',
    component: resolve => require(['../page/stall/device'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete'
      }
    }
  },
  {
    path: '/stall/product',
    name: 'stallProduct',
    component: resolve => require(['../page/stall/product'], resolve),
    meta: {
      permissions: {
        create: 'create',
        delete: 'delete',
        changePrice: 'changePrice',
        deleteAll: 'deleteAll',
        detail: 'detail',
        resetDown: 'resetDown',
        exportChangePrice: 'exportChangePrice',
        importChangePrice: 'importChangePrice'
      }
    }
  },
  {
    path: '/stall/typequery',
    name: 'stallTypeQuery',
    component: resolve => require(['../page/stall/type-query'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/stall/usagequery',
    name: 'stallUsageQuery',
    component: resolve => require(['../page/stall/usage-query'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/stall/utilitybill',
    name: 'utilityBillList',
    component: resolve => require(['../page/stall/utility-bill'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete',
        export: 'export'
      }
    }
  },
  {
    path: '/screen/touch',
    name: 'touchscreen',
    component: resolve => require(['../page/system/touch-screen'], resolve)
  },
  {
    path: '/screen/merchant',
    name: 'merchantScreen',
    component: resolve => require(['../page/system/merchant-screen'], resolve)
  },
  {
    path: '/stall/contract',
    name: 'contractList',
    component: resolve => require(['../page/stall/contract'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete',
        export: 'export'
      }
    }
  },
  {
    path: '/stall/rental',
    name: 'rentalList',
    component: resolve => require(['../page/stall/rental'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete',
        export: 'export'
      }
    }
  },
  {
    path: '/stall/product/productpricelog',
    name: 'productPriceLog',
    component: resolve => require(['../page/stall/product-priceLog'], resolve),
    meta: {
      framePage: true,
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/article/screen',
    name: 'screen',
    alias: '/firectrl/screen'
  },
  {
    path: '/article/screen/detail',
    name: 'screenDetail',
    alias: '/firectrl/screen/detail'
  }
]

const passengerFlowRoutes = [
  {
    path: '/passengerflow/passengerflowmeterconfig',
    name: 'passengerFlowMeterConfig',
    component: resolve => require(['../page/passenger-flow/passenger-flow-meter-config'], resolve),
    meta: {
      permissions: {
        create: 'create'
      }
    }
  }
]

const merchantRoutes = [
  {
    path: '/merchant/complain',
    name: 'complainList',
    component: resolve => require(['../page/merchant/complain'], resolve),
    meta: {
      permissions: {
        export: 'export',
        update: 'update'
      }
    }
  },
  {
    path: '/merchant/evaluation',
    name: 'evaluationList',
    component: resolve => require(['../page/merchant/evaluation'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/merchant/merchant',
    name: 'merchantList',
    component: resolve => require(['../page/merchant/merchant'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete'
      }
    }
  },
  {
    path: '/merchant/praise',
    name: 'praiseList',
    component: resolve => require(['../page/merchant/praise'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/article/reward',
    name: 'reward',
    alias: '/merchant/reward'
  },
  {
    path: '/article/reward/detail',
    name: 'rewardDetail',
    alias: '/merchant/reward/detail'
  },
  {
    path: '/article/punishment',
    name: 'punishment',
    alias: '/merchant/punishment'
  },
  {
    path: '/article/punishment/detail',
    name: 'punishmentDetail',
    alias: '/merchant/punishment/detail'
  }
]

const productRoutes = [
  {
    path: '/product/product',
    name: 'productList',
    component: resolve => require(['../page/product/product'], resolve),
    meta: {
      permissions: {
        create: 'create',
        delete: 'delete',
        update: 'update',
        tag: 'tag',
        unit: 'unit'
      }
    }
  },
  {
    path: '/product/product/tag',
    name: 'productTag',
    component: resolve => require(['../page/product/tag'], resolve),
    meta: {
      framePage: true,
      permissions: {
        createTag: 'createTag',
        deleteTag: 'deleteTag',
        updateTag: 'updateTag'
      }
    }
  },
  {
    path: '/product/product/unit',
    name: 'productUnit',
    component: resolve => require(['../page/product/unit'], resolve),
    meta: {
      framePage: true,
      permissions: {
        createUnit: 'createUnit',
        deleteUnit: 'deleteUnit',
        updateUnit: 'updateUnit'
      }
    }
  },
  {
    path: '/product/productclass',
    name: 'productClass',
    component: resolve => require(['../page/product/product-class'], resolve),
    meta: {
      permissions: {
        create: 'create',
        delete: 'delete',
        update: 'update'
      }
    }
  },
  {
    path: '/product/supplier',
    name: 'supplier',
    component: resolve => require(['../page/product/supplier'], resolve),
    meta: {
      permissions: {
        create: 'create',
        delete: 'delete',
        update: 'update',
        settle: 'settle'
      }
    }
  }
]

const saleRoutes = [
  {
    path: '/sale/billpayment',
    name: 'billPayment',
    component: resolve => require(['../page/sale/billPayment'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/sale/billsale',
    name: 'billSale',
    component: resolve => require(['../page/sale/billSale'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/sale/dayreport',
    name: 'dayReport',
    component: resolve => require(['../page/sale/dayReport'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  }
]

const foodsafetyRoutes = [
  {
    path: '/foodsafety/productaccessaccount',
    name: 'productAccessAccountList',
    component: resolve => require(['../page/foodsafety/product-accessAccount'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete',
        export: 'export',
        import: 'import',
        quickAdd: 'quickAdd'
      }
    }
  },
  {
    path: '/foodsafety/productaccountadjust',
    name: 'productAccountAdjustList',
    component: resolve => require(['../page/foodsafety/product-accountAdjust'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete',
        export: 'export'
      }
    }
  },
  {
    path: '/foodsafety/producttestrecord',
    name: 'productTestRecordList',
    component: resolve => require(['../page/foodsafety/product-test-record'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete',
        export: 'export',
        import: 'import'
      }
    }
  },
  {
    path: '/foodsafety/producttrace',
    name: 'productTraceList',
    component: resolve => require(['../page/foodsafety/product-trace'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  }
]

const infoRoutes = [
  {
    path: '/article/info_institution',
    name: 'infoInstitution',
    alias: '/info/institution'
  },
  {
    path: '/article/info_institution/detail',
    name: 'infoInstitutionDetail',
    alias: '/info/institution/detail'
  },
  {
    path: '/article/info_activity',
    name: 'infoActivity',
    alias: '/info/activity'
  },
  {
    path: '/article/info_activity/detail',
    name: 'infoActivityDetail',
    alias: '/info/activity/detail'
  },
  {
    path: '/article/info_dynamic',
    name: 'infoDynamic',
    alias: '/info/dynamic'
  },
  {
    path: '/article/info_dynamic/detail',
    name: 'infoDynamicDetail',
    alias: '/info/dynamic/detail'
  },
  {
    path: '/article/info_info',
    name: 'infoInfo',
    alias: '/info/info'
  },
  {
    path: '/article/info_info/detail',
    name: 'infoInfoDetail',
    alias: '/info/info/detail'
  },
  {
    path: '/article/info_popularscience',
    name: 'infoPopularScience',
    alias: '/info/popularscience'
  },
  {
    path: '/article/info_popularscience/detail',
    name: 'infoPopularScienceDetail',
    alias: '/info/popularscience/detail'
  },
  {
    path: '/article/info_navigation',
    name: 'infoNavigation',
    alias: '/info/infonavigation'
  },
  {
    path: '/article/info_navigation/detail',
    name: 'infoNavigationDetail',
    alias: '/info/infonavigation/detail'
  },
  {
    path: '/article/safety_lifesaving',
    name: 'safetyLifesaving',
    alias: '/info/safetylifesaving'
  },
  {
    path: '/article/safety_lifesaving/detail',
    name: 'safetyLifesavingDetail',
    alias: '/info/safetylifesaving/detail'
  },
  {
    path: '/article/job_responsibilities',
    name: 'jobResponsibilities',
    alias: '/info/jobresponsibilities'
  },
  {
    path: '/article/job_responsibilities/detail',
    name: 'jobResponsibilitiesDetail',
    alias: '/info/jobresponsibilities/detail'
  },
  {
    path: '/article/party_policy',
    name: 'partyPolicy',
    alias: '/info/partypolicy'
  },
  {
    path: '/article/party_policy/detail',
    name: 'partyPolicyDetail',
    alias: '/info/partypolicy/detail'
  },
  {
    path: '/article/staff_training_records',
    name: 'staffTrainingRecords',
    alias: '/info/stafftrainingrecords'
  },
  {
    path: '/article/staff_training_records/detail',
    name: 'staffTrainingRecordsDetail',
    alias: '/info/stafftrainingrecords/detail'
  }
]

const statisticsRoutes = [
  {
    path: '/statistics/salebypro',
    name: 'saleByProList',
    component: resolve => require(['../page/statistics/sale-byPro'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/statistics/salebyclass',
    name: 'saleByClassList',
    component: resolve => require(['../page/statistics/sale-byClass'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/statistics/paybymerchant',
    name: 'payByMerchantList',
    component: resolve => require(['../page/statistics/pay-byMerchant'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/statistics/salebydevice',
    name: 'saleByDeviceList',
    component: resolve => require(['../page/statistics/sale-byDevice'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/statistics/salebymerchant',
    name: 'saleByMerchantList',
    component: resolve => require(['../page/statistics/sale-byMerchant'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/statistics/salebymerchantclass',
    name: 'saleByMerchantClassList',
    component: resolve => require(['../page/statistics/sale-byMerchantClass'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/statistics/memberCard',
    name: 'memberCardList',
    component: resolve => require(['../page/statistics/memberCard'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/statistics/memberexpensebymerchant',
    name: 'memberexpensebymerchant',
    component: resolve => require(['../page/statistics/member-expensebyMerchant'], resolve),
    meta: {
      permissions: {
        memberExpenseExport: 'memberExpenseExport'
      }
    }
  },
  {
    path: '/statistics/memberexpensebymerchant/memberexpensebymerchantdetail',
    name: 'memberexpensebymerchantdetail',
    component: resolve => require(['../page/statistics/member-expensebyMerchant-detail'], resolve),
    meta: {
      framePage: true,
      permissions: {
        memberConsumeRecordExport: 'memberConsumeRecordExport'
      }
    }
  },
  {
    path: '/statistics/productaccesssale',
    name: 'productaccesssale',
    component: resolve => require(['../page/statistics/product-accessSale'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  }
]

const propertyRoutes = [
  {
    path: '/property/repairapplication',
    name: 'repairApplicationList',
    component: resolve => require(['../page/property/repair-application'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete',
        export: 'export'
      }
    }
  },
  {
    path: '/property/projectacceptance',
    name: 'projectAcceptanceList',
    component: resolve => require(['../page/property/projectAcceptance'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete',
        export: 'export'
      }
    }
  }
]

const articleRoutes = [
  {
    path: '/article/:code',
    name: 'article',
    component: resolve => require(['../page/article/article'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete',
        export: 'export'
      }
    }
  },
  {
    path: '/article/:code/detail',
    name: 'articleDetail',
    component: resolve => require(['../page/article/article-detail'], resolve),
    meta: {
      framePage: true
    }
  }
]

const firectrlRoutes = [
  {
    path: '/article/firectrl_plan',
    name: 'firectrlPlan',
    alias: '/firectrl/plan'
  },
  {
    path: '/article/firectrl_plan/detail',
    name: 'firectrlPlanDetail',
    alias: '/firectrl/plan/detail'
  },
  {
    path: '/article/firectrl_equipment',
    name: 'firectrlEquipment',
    alias: '/firectrl/equipment'
  },
  {
    path: '/article/firectrl_equipment/detail',
    name: 'firectrlEquipmentDetail',
    alias: '/firectrl/equipment/detail'
  },
  {
    path: '/article/firectrl_checkday',
    name: 'firectrlCheckday',
    alias: '/firectrl/checkday'
  },
  {
    path: '/article/firectrl_checkday/detail',
    name: 'firectrlCheckdayDetail',
    alias: '/firectrl/checkday/detail'
  },
  {
    path: '/article/firectrl_checkweek',
    name: 'firectrlCheckweek',
    alias: '/firectrl/checkweek'
  },
  {
    path: '/article/firectrl_checkweek/detail',
    name: 'firectrlCheckweekDetail',
    alias: '/firectrl/checkweek/detail'
  },
  {
    path: '/article/firectrl_checkmonth',
    name: 'firectrlCheckmonth',
    alias: '/firectrl/checkmonth'
  },
  {
    path: '/article/firectrl_checkmonth/detail',
    name: 'firectrlCheckmonthDetail',
    alias: '/firectrl/checkmonth/detail'
  },
  {
    path: '/article/firectrl_escapemap',
    name: 'firectrlEscapemap',
    alias: '/firectrl/escapemap'
  },
  {
    path: '/article/firectrl_escapemap/detail',
    name: 'firectrlEscapemapDetail',
    alias: '/firectrl/escapemap/detail'
  },
  {
    path: '/article/firectrl_equipmentmap',
    name: 'firectrlEquipmentmap',
    alias: '/firectrl/equipmentmap'
  },
  {
    path: '/article/firectrl_equipmentmap/detail',
    name: 'firectrlEquipmentmapDetail',
    alias: '/firectrl/equipmentmap/detail'
  },
  {
    path: '/article/firectrl_training',
    name: 'firectrlTraining',
    alias: '/firectrl/training'
  },
  {
    path: '/article/firectrl_training/detail',
    name: 'firectrlTrainingDetail',
    alias: '/firectrl/training/detail'
  }
]

const memberRoutes = [
  {
    path: '/member/member',
    name: 'memberList',
    component: resolve => require(['../page/member/member'], resolve),
    meta: {
      permissions: {
        create: 'create',
        delete: 'delete',
        update: 'update',
        memberTag: 'memberTag',
        memberLevel: 'memberLevel'
      }
    }
  },
  {
    path: '/member/member/level',
    name: 'memberLevel',
    component: resolve => require(['../page/member/level'], resolve),
    meta: {
      framePage: true,
      permissions: {
        createMemberLevel: 'createMemberLevel',
        deleteMemberLevel: 'deleteMemberLevel',
        updateMemberLevel: 'updateMemberLevel'
      }
    }
  },
  {
    path: '/member/member/tag',
    name: 'memberTag',
    component: resolve => require(['../page/member/tag'], resolve),
    meta: {
      framePage: true,
      permissions: {
        createMemberTag: 'createMemberTag',
        deleteMemberTag: 'deleteMemberTag',
        updateMemberTag: 'updateMemberTag'
      }
    }
  },
  {
    path: '/member/member/expenserecord',
    name: 'memberExpenseRecord',
    component: resolve => require(['../page/member/expenseRecord'], resolve),
    meta: {
      framePage: true,
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/member/cardclass',
    name: 'memberCardClass',
    component: resolve => require(['../page/member/card-class'], resolve),
    meta: {
      permissions: {
        create: 'create',
        delete: 'delete',
        update: 'update'
      }
    }
  },
  {
    path: '/member/rechargeplan',
    name: 'memberRechargePlan',
    component: resolve => require(['../page/member/rechargePlan'], resolve),
    meta: {
      permissions: {
        create: 'create',
        delete: 'delete',
        update: 'update'
      }
    }
  },
  {
    path: '/member/moneyrecord',
    name: 'memberMoneyRecord',
    component: resolve => require(['../page/member/moneyRecord'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/member/pointsrecord',
    name: 'memberPointsRecord',
    component: resolve => require(['../page/member/pointsRecord'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/member/operaterecord',
    name: 'memberOperateRecord',
    component: resolve => require(['../page/member/operateRecord'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/member/analyze',
    name: 'memberAnalyze',
    component: resolve => require(['../page/member/analyze'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/member/membercardbalance',
    name: 'memberCardBalance',
    component: resolve => require(['../page/member/memberCard-balance'], resolve),
    meta: {
      permissions: {
        export: 'export'
      }
    }
  },
  {
    path: '/member/membermoneyrecordabnormal',
    name: 'memberMoneyRecordAbnormal',
    component: resolve => require(['../page/member/member-moneyRecord-abnormal'], resolve),
    meta: {
      permissions: {
        export: 'export',
        adjust: 'adjust'
      }
    }
  },
  {
    path: '/member/randomdiscount',
    name: 'memberRandomDiscount',
    component: resolve => require(['../page/member/randomDiscount'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update'
      }
    }
  }
]

const systemRoutes = [
  {
    path: '/system/shop',
    name: 'shopList',
    component: resolve => require(['../page/system/shop'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete'
      }
    }
  },
  {
    path: '/system/role',
    name: 'userRole',
    component: resolve => require(['../page/user/role'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete',
        permissions: 'permissions'
        // rolePermission: 'rolePermission'
      }
    }
  },
  {
    path: '/system/user',
    name: 'userList',
    component: resolve => require(['../page/user/user'], resolve),
    meta: {
      permissions: {
        create: 'create',
        update: 'update',
        delete: 'delete',
        tag: 'tag',
        editpassword: 'editpassword'
      }
    }
  },
  {
    path: '/system/user/tag',
    name: 'userTag',
    component: resolve => require(['../page/user/tag'], resolve),
    meta: {
      framePage: true,
      permissions: {
        createTag: 'createTag',
        updateTag: 'updateTag',
        deleteTag: 'deleteTag'
      }
    }
  },
  {
    path: '/system/paymenttype',
    name: 'paymentType',
    component: resolve => require(['../page/system/paymenttype'], resolve),
    meta: {
      permissions: {
        update: 'update'
      }
    }
  },
  {
    path: '/system/config',
    name: 'config',
    component: resolve => require(['../page/system/config'], resolve)
  },
  {
    path: '/system/publicsetting',
    name: 'publicsetting',
    component: resolve => require(['../page/system/public-setting'], resolve),
    meta: {
      permissions: {
        update: 'update'
      }
    }
  }
]

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: { requiresAuth: false },
    component: resolve => require(['../page/account/login'], resolve)
  },
  {
    path: '/wxlogin',
    name: 'wxlogin',
    meta: { requiresAuth: false },
    component: resolve => require(['../page/account/wxlogin'], resolve)
  },
  {
    path: '/register',
    name: 'register',
    meta: { requiresAuth: false },
    component: resolve => require(['../page/account/register'], resolve)
  },
  ...articleRoutes,
  ...productRoutes,
  ...memberRoutes,
  ...statisticsRoutes,
  ...stallRoutes,
  ...systemRoutes,
  ...saleRoutes,
  ...propertyRoutes,
  ...foodsafetyRoutes,
  ...firectrlRoutes,
  ...merchantRoutes,
  ...infoRoutes,
  ...passengerFlowRoutes,
  {
    path: '/',
    meta: { requiresAuth: true },
    component: resolve => require(['../page/index'], resolve)
  },
  {
    path: '',
    name: 'index'
  },
  {
    path: '/401',
    name: '401',
    meta: { requiresAuth: false },
    component: resolve => require(['../page/401'], resolve)
  },
  {
    path: '*',
    name: '404',
    meta: { requiresAuth: false },
    component: resolve => require(['../page/404'], resolve)
  }
]

const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requiresAuth === undefined || r.meta.requiresAuth === null || r.meta.requiresAuth) && to.path !== '/401') {
    if (store.getters.isAuthed) {
      store.dispatch('ReactivateModule', to.path)
      next()
    } else {
      if (to.query.grant_type === 'authorization_token') {
        next({
          path: '/wxlogin', query: {t: to.query.t, grant_type: to.query.grant_type}
        })
      } else {
        next({
          path: '/login', query: {return: to.path}
        })
      }
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js